import { gql } from "@apollo/client";

export const organizationAuthorizedOperationsFragment = gql`
    fragment OrganizationAuthorizedOperations on CameraKitOrganization {
        orgAuthorizedOperations {
            authOperation
            authOperationTypes
        }
    }
`;
